export const UPDATE_CRITERIA_TAB = ' UPDATE_CRITERIA_TAB';
export const UPDATE_EXPORT_TAB = 'UPDATE_EXPORT_TAB';
